module.exports = __webpack_public_path__ + "media/images/redesign-images/ma/profile-images-old/megan-hester-f7ad8dde782a3dd240e7155f592bf95a.jpg";